import { defineMessage } from 'services/localization';

export const messages = {
    optionBackupCodes: defineMessage('backup_codes'),
    optionBackupEmail: defineMessage('backup_email'),
    buttonEdit: defineMessage('edit'),
    buttonAdd: defineMessage('add'),
    addBackupEmailTitle: defineMessage('add_backup_email_address'),
    editBackupEmailTitle: defineMessage('update_backup_email_address'),
};
